import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerBean,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
  SalesOrderListDetailsRequest,
  SalesOrderListReportCriteria,
  SalesPersonBean,
} from "../ds/ds.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class SalesOrderRegister extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "SalesOrder Register Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      salesPersons: [],
      customerList: new Array(),
      salesPersonBean: new SalesPersonBean(),
      summaryData: null,
      criteria: new SalesOrderListReportCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowCustomerModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      isCollapsible_open: true,
      customerData: new CustomerBean(),
      spData: null,
      customerDatas: [],
      salesPersonDatas: [],
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    ModuleUtils.getSalesOrderStatusList();
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      let suggestion = [];
      let salesPersonBean = new SalesPersonBean();
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
        salesPersonBean: salesPersonBean,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readSalesPerson(salesPersonCode);
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonBean: salesPersonBean });
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      let suggestion = [];
      let customerData = new CustomerBean();
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
        customerData: customerData,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    //this.readCustomer(customerCode);
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    readrestInput.isLockRequired = false;
    CustomerService.readCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.errorCallBack
    );
  };

  editCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ customerData: customerData, criteria: criteria });
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (response.data != null && response.data.customerPageList != null) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadSalesOrderRegisterInquiryList(criteria);
  };
  loadSalesOrderRegisterInquiryList = (criteria) => {
    if (SecurityAccessManager.SalesOrderRegisterInquiry_IsAccessible()) {
      ReportService.inquireSalesOrderListDetailsReport(
        criteria,
        this.loadSalesOrderRegisterPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadSalesOrderRegisterPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let invoiceInfoDataList = [];
      let summaryData = [];
      summaryData = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.salesOrderReportBean)) {
        invoiceInfoDataList = response.data.resultBean.salesOrderReportBean;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: invoiceInfoDataList,
        summaryData: summaryData,
        isCollapsible_open: false,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SalesOrderListReportCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.salesPersonCode = "";
    this.setState({
      criteria: criteria,
      customerDatas: [],
      salesPersonDatas: [],
      customerData: [],
      salesPersonData: [],
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new SalesOrderListReportCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.salesPersonCode = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      customerDatas: [],
      salesPersonDatas: [],
      customerData: null,
      salesPersonData: null,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isCollapsible_open: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new SalesOrderListDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.SalesOrderRegisterInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateSalesOrderListDetailsReport(
          listRequest,
          this.generateSalesOrderPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.SalesOrderRegisterInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateSalesOrderListDetailsReport(
          listRequest,
          this.generateSalesOrderPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateSalesOrderPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateSalesOrderPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        if (!isEmptyString(reportFilePath)) {
           window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  addCustomer = () => {
    let criteria = this.state.criteria;
    criteria.customerCode = "";
    criteria.companyCode = this.companyCode;
    let customerData = this.state.customerData;
    let customerDatas = this.state.customerDatas;
    if (customerData != null) {
      if (!isEmptyArray(customerDatas)) {
        let exists = customerDatas.find((p) => p.code === customerData.code);
        if (!exists) {
          customerDatas.push(customerData);
          criteria.customerCodes.push(customerData.code);
          this.setState({
            criteria: criteria,
            customerDatas: customerDatas,
            customerData: null,
          });
        }
      } else {
        if (!isEmptyString(customerData.code)) {
          customerDatas.push(customerData);
          criteria.customerCodes.push(customerData.code);
          this.setState({
            criteria: criteria,
            customerDatas: customerDatas,
            customerData: null,
          });
        }
      }
    }
  };
  addSalesPerson = () => {
    let criteria = this.state.criteria;
    criteria.salesPersonCode = "";
    let salesPersonBean = this.state.salesPersonBean;
    let salesPersonDatas = this.state.salesPersonDatas;
    if (salesPersonBean != null) {
      if (!isEmptyArray(salesPersonDatas)) {
        let exists = salesPersonDatas.find(
          (p) => p.code === salesPersonBean.code
        );
        if (!exists) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      } else {
        if (!isEmptyString(salesPersonBean.code)) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      }
    }
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  deleteCustomer = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.customerCodes;
    let customerDatas = this.state.customerDatas;
    customerDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        customerDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, customerData: null });
  };

  deleteSalesPerson = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.salesPersonCodes;
    let salesPersonDatas = this.state.salesPersonDatas;
    salesPersonDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        salesPersonDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, salesPersonBean: null });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  getCaption = (status) => {
    return ModuleUtils.getSalesOrderStatusCaption(status);
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder", "salesOrderNumber", true)

        .setStyleDetails("left", "", "", "wt-3", "wt-3")

        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "orderDate", true)

        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "orderStartDate", true)

        .setStyleDetails("left", "2", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true)

        .setStyleDetails("left", "2", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)

        .setStyleDetails("left", "", "", "wt-4", "wt-3")

        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustPO", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "orderStatus", true, false)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPersons", "salesPersonCode", true, false)

        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickedUp By", "", true, false)

        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickedUp Date", "", true, false)

        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AdjustedQty", "adjustedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalAdjustedQuantity")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "salesOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalSalesOrderQuantity")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShippedTotal", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalShippedQuantity")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("GrandTotal", "grandTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "totalGrandTotalAmount")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let summaryDetail = this.state.summaryData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          showHideSecondHeader={this.showHideSecondHeader}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          addCustomer={this.addCustomer}
          addSalesPerson={this.addSalesPerson}
          deleteCustomer={this.deleteCustomer}
          deleteSalesPerson={this.deleteSalesPerson}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
        />
        <div>
          {this.state.isInquiryDatasFound && (
            <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              subHeaderData={summaryDetail}
              label={"Inquiry Data List"}
            />
          </div>
          )}
        </div>

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
      customerList: this.props.customerList,
      isCollapsible_open: this.props.isCollapsible_open,
    };
    this.customerCodeRef = React.createRef();
    this.salesPersonCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.customerCodeRef.current != null) {
      this.customerCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  deleteCustomer = (e,val, rowData) => {
    this.props.deleteCustomer(rowData);
  };
  deleteSalesPerson = (e,val, rowData) => {
    this.props.deleteSalesPerson(rowData);
  };
  salesPersonColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
        "SalesPerson",
          "code",
          true
        )
        .setStyleDetails("left")   
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
        "Name",
          "description",
          true
        )
        .setStyleDetails("left")   
    );
   
    columns.push(
      new ColumnDefinition()
      .setDetails("", <DeleteIcon />, false)
      .setClickDetails(false, true, this.deleteSalesPerson, <DeleteIcon />)
    );
  
    return columns;
  };
  customerColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
        "CustomerCode",
          "code",
          true
        )
        .setStyleDetails("left")   
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
        "Name",
          "description",
          true
        )
        .setStyleDetails("left")   
    );
   
    columns.push(
      new ColumnDefinition()
      .setDetails("", <DeleteIcon />, false)
      .setClickDetails(false, true, this.deleteCustomer, <DeleteIcon />)
    );
  
    return columns;
  };
 
  addCustomer = (e) => {
    if (e.detail === 1) {
      this.props.addCustomer();
      if (this.customerCodeRef != null) {
        this.customerCodeRef.current.clear();
        this.customerCodeRef.current.focus();
      }
    }
  };
  addSalesPerson = (e) => {
    if (e.detail === 1) {
      this.props.addSalesPerson();
      if (this.customerCodeRef != null) {
        this.salesPersonCodeRef.current.clear();
        this.salesPersonCodeRef.current.focus();
      }
    }
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  salesPersonCodeOnChange = (e) => {
    this.props.salesPersonCodeOnChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };

  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };

  salesPersonEnterKeyEventHandler = (e) => {
    this.props.salesPersonEnterKeyEventHandler(e);
  };

  displayAutoCompleteSalesPersonList = () => {
    this.props.displayAutoCompleteSalesPersonList();
  };

  render() {
    let criteria = this.props.criteria;
    let customerDatas = this.props.customerDatas;
    let salesPersonDatas = this.props.salesPersonDatas;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.customerCodeRef}
                name="customerCode"
                onChange={this.customerCodeOnChange}
                value={criteria.customerCode}
                lookupRequired={true}
                lookupHandler={this.state.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.customerPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteList}
                showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addCustomer(e)}
                disabled={isDisableFields}
              >
                Add
              </Button>
            </Col>
            <Col sm="1">
              <FormLabel>SalesPerson</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.salesPersonCodeRef}
                name="salesPersonCode"
                onChange={this.salesPersonCodeOnChange}
                value={criteria.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                enterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.salesPersonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteSalesPersonList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteSalesPersonList
                }
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addSalesPerson(e)}
                disabled={isDisableFields}
              >
                Add
              </Button>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>FromOrderDate</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="fromOrderDate"
                onChange={this.onChange}
                value={criteria.fromOrderDate}
                disabled={isDisableFields}
              />
            </Col>
            <Col>
              <CollapseComponent
                isOpen={this.props.isCollapsible_open}
                onClick={(e) => this.showHideSecondHeader(e)}
              />
            </Col>
          </Row>
        </div>
        {this.props.isCollapsible_open && (
          <div className="div_inline">
            <div className="div_3_equal_no_height">
             
               <CustomTable
data={customerDatas}
columns={this.customerColumnDefinitions()}
label={"Customer Data List"}
/>
            </div>
            <div className="div_3_equal_no_height">
            
                 <CustomTable
data={salesPersonDatas}
columns={this.salesPersonColumnDefinitions()}
label={"SalesPerson Data List"}
              />
            </div>
            <div className="div_3_equal_no_height">
              <Row>
                <Col sm="">
                  <FormLabel>ToOrderDate</FormLabel>
                </Col>
                <Col sm="">
                  <DatePickerComponent_adv
                    name="toOrderDate"
                    onChange={this.onChange}
                    value={criteria.toOrderDate}
                    disabled={isDisableFields}
                  />
                </Col>
              </Row>
              {/* <Row>
                <Col sm="">
                  <FormLabel>FromStopDate</FormLabel>
                </Col>
                <Col sm="">
                  <DatePickerComponent
                    name="orderFromStopDate"
                    onChange={this.onChange}
                    value={criteria.orderFromStopDate}
                    disabled={isDisableFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="">
                  <FormLabel>ToStopDate</FormLabel>
                </Col>
                <Col sm="">
                  <DatePickerComponent
                    name="orderToStopDate"
                    onChange={this.onChange}
                    value={criteria.orderToStopDate}
                    disabled={isDisableFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="">
                  <FormLabel>Status</FormLabel>
                </Col>
                <Col sm="">
                  <FormControl
                    as="select"
                    custom
                    onChange={this.onChange}
                    name="orderSelectionStatus"
                    value={criteria.orderSelectionStatus}
                    disabled={isDisableFields}
                  >
                    <option value={0}>All</option>
                    <option value={1}>Open</option>
                    <option value={2}>UnApproved</option>
                    <option value={3}>Invoiced</option>
                    <option value={4}>Cancelled</option>
                  </FormControl>
                </Col>
              </Row> */}
              <Row></Row>
            </div>
          </div>
        )}
      </div>
    );
  }
}
function SalesOrderRegisterInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SalesOrderRegister {...props} name="" /> <br />
    </div>
  );
}
export default SalesOrderRegisterInquiry;
